module.exports = __webpack_public_path__ + "img/guiji.c55c64ce.png";